import type { Ga4StandardEventName, YohoCustomEventName } from "./events"
import { buildAnalyticsContext } from "./context"

export type AnalyticsParamValue = string | number | boolean | null | undefined
export type AnalyticsParams = Record<string, AnalyticsParamValue>

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
    flutterMethod?: (method: string, ...args: any[]) => void
  }
}

const FORBIDDEN_PARAM_PATTERNS = [
  /email/i,
  /phone/i,
  /verification.*code/i,
  /^code$/i,
  /token/i,
  /payload/i,
  /chat.*content/i,
  /message$/i,
  /raw/i,
  /iccid$/i,
]

function assertNoForbiddenParams(params: AnalyticsParams) {
  const forbiddenKey = Object.keys(params).find((key) =>
    FORBIDDEN_PARAM_PATTERNS.some((pattern) => pattern.test(key))
  )

  if (forbiddenKey) {
    throw new Error(`[analytics] forbidden GA4 parameter: ${forbiddenKey}`)
  }
}

function getDataLayer() {
  if (typeof window === "undefined") {
    throw new Error("[analytics] dataLayer requires a browser window")
  }

  window.dataLayer = window.dataLayer || []
  return window.dataLayer
}

function getCurrentPathname(params: AnalyticsParams) {
  const routePath = params.route_path
  if (typeof routePath === "string" && routePath.startsWith("/")) return routePath
  return window.location.pathname
}

export function trackYohoEvent(event: YohoCustomEventName, params: AnalyticsParams = {}) {
  assertNoForbiddenParams(params)
  const pathname = getCurrentPathname(params)
  const context = buildAnalyticsContext(pathname)
  getDataLayer().push({
    event,
    ...context,
    ...params,
  })
}

export function trackGa4StandardEvent(event: Ga4StandardEventName, params: AnalyticsParams = {}) {
  assertNoForbiddenParams(params)
  const pathname = getCurrentPathname(params)
  const context = buildAnalyticsContext(pathname)
  getDataLayer().push({
    event,
    ...context,
    ...params,
  })
}
